import { ILimit } from '../../interfaces';

export const eventDataToLimits = (event: MessageEvent): Array<ILimit>  => (
    event.data?.data.map((data: Array<ILimit>) => ({
        ...data,
        checkDateUtc: event.data.checkDateUtc,
    }))
);
